import React from 'react';
import DefaultQuestionnaireModal from './DefaultQuestionnaireModal';
import setupDefaultImage from '/images/setup-default-questionnaire.png';

interface SetupDefaultModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SetupDefaultModal: React.FC<SetupDefaultModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <DefaultQuestionnaireModal
      isOpen={isOpen}
      size="lg"
      setup={true}
      onClose={onClose}
      footer={
        <div className="dq-modal-footer dq-modal-footer--setup">
          <button className="dq-btn dq-btn--close-window" onClick={onClose}>
            Close Window
          </button>
        </div>
      }
    >
      <h4 className="dq-setup-heading">How to Setup Your Default Questionnaire</h4>
      <p className="dq-setup-description">
        Default questionnaire will automatically attach to new job listings. You can always change or remove them any time.
      </p>
      <ol className="dq-setup-steps">
        <li className="dq-setup-step">Go to the “Questionnaire” tab and find your desired questionnaire</li>
        <li className="dq-setup-step">
          Click ”Kebab Icon” beside view button
        </li>
        <li className="dq-setup-step">
          Select ”Set as Default”
        </li>
      </ol>
      <img src={setupDefaultImage} alt="Default Questionnaire Setup" draggable={false} style={{ width: '100%', borderRadius: '8px', border: '1px solid #DEE2E6', marginBottom: '0.5rem', userSelect: 'none' }} />
    </DefaultQuestionnaireModal>
  );
};

export default SetupDefaultModal;
